/* eslint-disable react-hooks/rules-of-hooks */
import utils from '@/utils';
import quickModal from '@/utils/quickModal';
import requester, { IRequesterResponse } from '@/utils/requester';
import _ from 'lodash';
import { StateCreator, create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

interface IAuthState {
  user?: any;
  token?: string;
  remember?: boolean;
  setToken: (token: string) => void;
  setShareToken: (token?: string) => void;
  logout: () => void;
  login: (values: { username: string; password: string; remember?: boolean }) => any;
  loginWithToken: (values: { userToken: string }) => void;
  getToken: () => string;
}

const initValue = {
  user: undefined,
  remember: false,
  token: '',
};

const useAuth = create<IAuthState>(
  devtools(
    persist(
      (set, get) => ({
        ...initValue,
        setToken: (token) => {
          set((state) => ({ ...state, token }));
        },
        setShareToken: (token) => {
          set((state) => ({ ...state, shareToken: token }));
        },
        getToken: () => {
          return get().token || '';
        },
        async login(values) {
          utils.loading(true);

          try {
            const { data } = (await requester.post('/user/v1/users/login', {
              username: utils.cleanPhone(values.username),
              password: values.password,
            })) as IRequesterResponse;

            if (!_.intersection(['doctor', 'super_admin', 'supporter'], data.roles)) {
              quickModal.error({ content: 'Bạn không có quyền đăng nhập vào hệ thống' });
              utils.loading(false);
              return;
            }

            set((state) => ({ ...state, user: data, token: data.token, remember: values.remember as boolean }));

            requester.defaults.headers.token = data.token;
            return data;
          } catch (error: any) {
            quickModal.error({ content: error?.response?.data?.error?.message || error.message });
            return;
          } finally {
            utils.loading(false);
          }
        },
        async loginWithToken(values) {
          utils.loading(true);
          try {
            const { data } = (await requester.post('/user/v1/users/login/cmst', {
              token: values.userToken,
            })) as IRequesterResponse;

            set((state) => ({ ...state, user: data, token: data.token, remember: true as boolean }));
            requester.defaults.headers.token = data.token;
            return data;
          } catch (error: any) {
            quickModal.error({ content: error?.response?.data?.error?.message || error.message });
            return;
          } finally {
            utils.loading(false);
          }
        },
        logout() {
          set(initValue);
          if (get().user) {
            window.location.href = '/';
          }
        },
      }),
      {
        name: 'auth-storage',
        storage: createJSONStorage(() => localStorage),
      },
    ),
    { name: 'auth' },
  ) as StateCreator<IAuthState>,
);

requester.logout = useAuth.getState().logout;
requester.getToken = useAuth.getState().getToken;
requester.setToken = useAuth.getState().setToken;

export default useAuth;
